<template lang="pug">
  v-container
    v-btn.float-right(fab color="pink accent-2" dark @click="helpDialog=true" aria-label="help")
      v-icon mdi-help
    h1.display-2.text-center Athletic Facility Reservation
    v-scroll-y-transition
      v-row(v-if="dataReady && hasAnySeasons")
        v-col(cols=12 lg=3 order-lg=2)
          v-row
            v-col(cols=12 v-if="isAdmin").py-0
              coach-selector.mb-4
            v-col(cols=12 v-if="coachId").py-0
              team-selector.mb-4
            v-col(cols=12 v-if="hasAnyPending").py-0
              cart-module.mb-4
            v-col(cols=12 v-if="coachId").py-0
              reservation-allowances-module.mb-4
            v-col(cols=12 v-if="coachId").py-0
              reserved-sessions-module.mb-4
        v-col(cols=12 lg=9)
          v-card(v-if="coachId")
            v-card-title
              facility-selector
            v-tabs(v-model="tab" height=0)
              v-tab
              v-tab-item.pa-4
                reservation-calendar
              v-tab
              v-tab-item
                slot-module
          v-card(v-else)
            v-card-text Select a coach to view reservations.
      p.body-1.text-center(v-else-if="dataReady") You are not registered as a coach for any active seasons.
      v-progress-linear(indeterminate v-else)
    v-dialog(v-model="helpDialog" :width="vidWidth")
      v-card
        v-card-title How to make reservations
        video-player.video-player-box(:options="video")
        v-card-actions
          v-btn(@click="helpDialog=false" color="primary") close
    error(v-if="error")
    standby(v-if="standby")
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from "vuex"
import error from "@/components/error"
import service from "@/data/service"
import standby from "@/components/standby";

import CartModule from "@/components/CartModule"
import CoachModule from "@/components/CoachModule"
import FacilitySelector from '@/components/FacilitySelector'
import ReservationAllowancesModule from "@/components/ReservationAllowancesModule"
import ReservationCalendar from "@/components/ReservationCalendar"
import ReservedSessionsModule from "@/components/ReservedSessionsModule"
import SeasonModule from "@/components/SeasonModule"
import SlotModule from "@/components/SlotModule"
import CoachSelector from "@/components/CoachSelector"
import TeamSelector from "@/components/TeamSelector"
import TextField from "@/components/TextField"

import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default Vue.extend({
  data: () => ({
    helpDialog: false
  }),
  components: {
    error,
    standby,
    CartModule,
    CoachModule,
    FacilitySelector,
    ReservationAllowancesModule,
    ReservationCalendar,
    ReservedSessionsModule,
    SeasonModule,
    SlotModule,
    CoachSelector,
    TeamSelector,
    TextField,
    videoPlayer
  },
  computed: {
    ...mapState({
      dataReady: state => state.main.dataReady,
      hasAnySeasons: state => state.main.seasonOptions.length > 0,
      hasAnyPending: state => state.main.pendingSessions.length > 0,
      loading: state => state.main.loading,
      isAdmin: state => state.auth.isAdmin,
      coachId: state => state.main.coachId
    }),
    ...mapGetters([
      "error",
      "standby"
    ]),
    tab: {
      get () {
        return this.$store.state.main.tab
      },
      set (value) {
        this.$store.commit('setTab', value)
      }
    },
    vidWidth() {
      let screenWidth = this.$vuetify.breakpoint.width
      let def = 800
      let margin = 48
      return def + margin < screenWidth ? def : screenWidth - margin
    },
    video() {
      return {
        sources: [{
          src: 'help.mp4',
          type: 'video/mp4'
        }],
        width: this.vidWidth
      }
    }
  },
  methods: {
    reserve(sessionId, teamId) {
      return service.createReservation(sessionId, teamId)
    },
    release(sessionId, teamId) {
      return service.deleteReservation(sessionId, teamId)
    },
    removeSession(sessionId) {
      this.pendingSessions = this.pendingSessions.reduce((acc, session) => {
        if(session.space.session_id != sessionId)
          acc.push(session)
        return acc
      }, [])
    },
    fetchDataOnChange() {
      this.$store.dispatch('initialize', this.$route.params.season_id)
    },
  },
  async mounted () {
    this.$store.commit('setTab', 0)
    await this.$store.dispatch('refresh')
    if(this.$store.state.main.firstTime) {
      this.helpDialog = true
      this.$store.commit('clearFirstTime')
    }
  },
  watch: {
    $route: "fetchDataOnChange"
  }
})
</script>
